import { render, staticRenderFns } from "./DisclaimerPhotoITA.vue?vue&type=template&id=67309406&"
import script from "./DisclaimerPhotoITA.vue?vue&type=script&lang=js&"
export * from "./DisclaimerPhotoITA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports